export default "__VITE_ASSET__27133d46__"